<template>
  <ux-modal
    class="change-password"
    width="720px"
    v-model="showModal"
    :title="$t('HT.register.setPsw')"
    :close="hideModal"
  >
    <div class="changepassword-cont">
      <!-- 进度条 -->
      <div class="changepassword-stepbox">
        <ux-steps :active="step" direction="vertical">
          <ux-step v-for="(item, idx) in stepSideList" :key="item" :title="item"></ux-step>
        </ux-steps>
      </div>
      <!-- 右侧内容 -->
      <div class="changepassword-verify">
        <ux-form
          v-if="step !== 3"
          class="my-vertical-form"
          ref="form"
          :rules="rules"
          :data="formData"
          hide-btn
          width="232px"
          hideRequired
        >
          <!-- 第一步 -->
          <template v-if="step === 1">
            <!-- tab栏 -->
            <div class="changepassword-tabbox" :class="'changepassword-tabbox-' + currentTab">
              <div
                :class="[
                  'changepassword-tab',
                  { 'changepassword-tab-active': currentTab === item.name }
                ]"
                v-for="item in list"
                :key="item.name"
                @click="tabClick(item)"
              >
                {{ item.label }}
              </div>
            </div>

            <!-- 当前手机号码 -->
            <template v-if="isCurrentPhone">
              <ux-form-item :label="$t('HT.changePsw.phone')" prop="phone" key="phone" :error="errorList.phone">
                <verify-phone v-model="formData.phone"></verify-phone>
              </ux-form-item>
            </template>

            <!-- 已绑定的邮箱地址 -->
            <template v-if="!isCurrentPhone && hasEmail">
              <ux-form-item
                :label="$t('HT.changePsw.email')"
                prop="email"
                key="email"
                :error="errorList.email"
              >
                <ux-input
                  noSpace
                  v-model="formData.email"
                  :placeholder="$t('HT.changePsw.email.placeholder')"
                ></ux-input>
              </ux-form-item>
            </template>

            <template v-if="isCurrentPhone || hasEmail">
              <!-- 图形验证码 -->
              <ux-form-item
                :label="$t('HT.imgcode')"
                prop="imgCode"
                key="imgCode"
                :error="errorList.imgCode"
              >
                <ux-input
                  noSpace
                  v-model="formData.imgCode"
                  :placeholder="$t('HT.imgcode')"
                  class="min-input"
                ></ux-input>
                <img-verify ref="refImgVerify" v-model="prefix" />
              </ux-form-item>

              <!-- 验证码 -->
              <ux-form-item :label="$t('HT.code')" prop="code" key="code" :error="errorList.code">
                <ux-input
                  noSpace
                  v-model="formData.code"
                  :placeholder="$t('HT.code')"
                  class="min-input"
                  :regular="regPositiveInteger"
                ></ux-input>
                <time-button ref="time" text :time="120" @click="getCode"></time-button>
              </ux-form-item>
            </template>

            <!-- 没有邮箱 提示绑定邮箱 -->
            <template v-if="!isCurrentPhone && !hasEmail">
              <div class="change-password-noemail">
                <div class="change-password-noemail-img result-info"></div>
                <div class="change-password-noemail-txt">
                  <ux-button type="primary" text @click="showBindEmail">{{$t('HT.changePsw.result.left')}}</ux-button>
                  <span> {{$t('HT.changePsw.result.right')}}</span>
                </div>
              </div>
            </template>
          </template>

          <!-- 第二步 -->
          <template v-if="step === 2">
            <!-- 新密码 -->
            <ux-form-item :label="$t('HT.newPassword')" prop="password" key="password" :error="errorList.password">
              <ux-input
                v-model="formData.password"
                :placeholder="$t('HT.passwdPlaceholder')"
                type="password"
                show-password
              ></ux-input>
            </ux-form-item>

            <!-- 校验密码 -->
            <ux-form-item
              :label="$t('HT.changePsw.passwdCheck')"
              prop="passwdCheck"
              key="passwdCheck"
              :error="errorList.passwdCheck"
            >
              <ux-input
                v-model="formData.passwdCheck"
                :placeholder="$t('HT.register.passwdCheck.placeholder')"
                type="password"
                show-password
              ></ux-input>
            </ux-form-item>
          </template>
        </ux-form>

        <!-- 第三步 -->
        <template v-else>
          <div class="change-password-result result-success"></div>
          <div class="result-msg">{{$t('HT.changePsw.msg')}}</div>
        </template>
      </div>
    </div>
    <template slot="footer">
      <div class="changepassword-footer">
        <ux-button v-show="!hideClose" plain @click="close">{{ closeText }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ confirmText }}</ux-button>
      </div>
    </template>
  </ux-modal>
</template>

<script>
import verifyPhone from '@c/verifyPhone/verifyPhone';
import { rules } from '@l/rules.js';
import timeButton from '@/views/template/timeButton';
import imgVerify from '@c/imgVerify/imgVerify';

export default {
  name: 'ChangePassword',
  components: {
    verifyPhone,
    timeButton,
    imgVerify
  },
  props: {
    // 旧手机
    phone: {
      type: String,
      default: ''
    },
    // 是否绑定邮箱
    hasEmail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      step: 1, // 第几步
      showModal: false,
      stepSideList: [this.$t('HT.resetPass.check'), this.$t('HT.resetPass.setNewPsw'), this.$t('HT.purchaseApi.step3')],
      regPositiveInteger: rules.positiveInteger().pattern, // 包括0正整数
      rules: this.$rul.changePassword(this),
      prefix: '', // 图形验证码前缀
      formData: {
        phone: this.phone,
        email: '',
        code: '',
        password: '', // 密码
        passwdCheck: '', // 二次密码
        imgCode: ''
      },
      list: [
        {
          label: this.$t('HT.changePsw.phone1'),
          name: 'phone'
        },
        {
          label: this.$t('HT.changePsw.account'),
          name: 'account'
        }
      ],
      currentTab: 'phone',
      // 错误信息
      errorList: {
        phone: '',
        email: '',
        code: '',
        password: '', // 密码
        passwdCheck: '', // 二次密码
        imgCode: ''
      }
    };
  },
  computed: {
    // 确认按钮文案
    confirmText() {
      const step = this.step;
      if (step === 2) {
        return this.$t('HT.changePsw.change');
      }
      if (step === 3) {
        return this.$t('HT.changePsw.reLogin');
      }
      return this.$t('HT.addApi.nextStep');
    },
    // 关闭按钮文案
    closeText() {
      return this.step === 2 ? this.$t('HT.addApi.prevStep') : this.$t('HT.cancel');
    },
    // 隐藏关闭按钮
    hideClose() {
      return this.step === 3;
    },
    isCurrentPhone() {
      return this.currentTab === 'phone';
    }
  },
  created() {
    this.formData.phone = this.phone;
    this.$nextTick(() => {
      this.showModal = true;
    });
  },

  methods: {
    /**
     * 切换登录方式
     * @param {Object} params 查询对象
     */
    tabClick(tab) {
      if (this.currentTab === tab.name) {
        return;
      }
      this.currentTab = tab.name;
    },

    /**
     * 获取验证码
     */
    getCode() {
      const isCurrentPhone = this.isCurrentPhone;
      const validateFieldKey = isCurrentPhone ? 'phone' : 'email';
      const errList = [];

      this.$refs['form'].validateField([validateFieldKey], (res) => {
        if (res) {
          errList.push(res);
        }
      });
      const { imgCode, phone, email } = this.formData;

      if (!imgCode) {
        this.errorList.imgCode = this.$t('HT.login.imgCode.placeholder');
        return;
      }

      if (errList.length === 0) {
        const params = {
          code: imgCode,
          prefix: this.prefix
        };
        let getCodeFnName = '';

        if (isCurrentPhone) {
          getCodeFnName = 'getResetPswPhoneCode';
          params.phone = phone;
        } else {
          getCodeFnName = 'getResetPswEmailCode';
          params.email = email;
        }
        this.$uxLoading.show();
        this.clearErrorMsg();

        this.$api.user[getCodeFnName](params, { hideMsg: true })
          .then((res) => {
            if (res.code == 10000) {
              this.$refs.time.start();
            }
          })
          .catch((err) => {
            const { sub_msg } = err.response.data;
            this.errorList.code = sub_msg;
            this.$refs.refImgVerify.getKaptcha();
            this.formData.imgCode = '';
          });
      }
    },

    /**
     * 验证手机号
     */
    personIdentify() {
      const codePrefixKey = this.isCurrentPhone ? 'phone' : 'email';
      const params = {
        code_prefix: this.formData[codePrefixKey],
        code: this.formData.code
      };
      this.$uxLoading.show();
      this.clearErrorMsg();
      this.$api.user
        .passwordIdentify(params, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.step++;
          }
        })
        .catch((err) => {
          const { sub_msg, sub_code } = err.response.data;
          if (sub_code === 'invalid.phone') {
            // 手机号错误
            this.errorList.phone = sub_msg;
          } else if (sub_code === 'invalid.email') {
            // 邮箱错误
            this.errorList.email = sub_msg;
          } else {
            // 验证码错误
            this.formData.code = '';
            this.$nextTick(() => {
              this.errorList.code = this.$t('HT.login.text2');
            });
          }
        });
    },

    // 修改密码
    personPassword() {
      const { code, password, phone, email } = this.formData;
      const params = {
        code,
        password,
        code_prefix: this.isCurrentPhone ? phone : email
      };
      this.$uxLoading.show();
      this.clearErrorMsg();
      this.$api.user
        .password(params, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.step++;
            this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          }
        })
        .catch((err) => {
          const { sub_msg, sub_code } = err.response.data;
          if (sub_code === 'invalid.code') {
            // 验证码被覆盖
            this.errorList.passwdCheck = this.$t('HT.changePsw.invalid');
          } else {
            this.errorList.passwdCheck = sub_msg;
          }
        });
    },

    /**
     * 退出登录
     */
    logout() {
      this.$store.commit('logout');
      this.$router.push('/login');
      this.$uxModal.hide();
    },

    /**
     * 前往绑定邮箱
     */
    showBindEmail() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
        this.$emit('show-bind-email');
      }, 500);
    },

    /**
     * 关闭弹窗
     */
    hideModal() {
      if (this.step === 3) {
        return this.logout();
      }

      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },

    /**
     * 取消回调
     */
    close() {
      const step = this.step;
      if (step === 1) {
        return this.hideModal();
      }
      this.step--;
    },

    /**
     * 确认回调
     */
    confirm() {
      const step = this.step;
      if (step === 3) {
        this.hideModal();
        // 重新登录
        this.logout();
        return;
      }

      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (step === 1) {
            this.personIdentify();
            return;
          }
          if (step === 2) {
            this.personPassword();
          }
        }
      });
    },
    /**
     * 清空错误信息
     */
    clearErrorMsg() {
      for (const key in this.errorList) {
        if (Object.hasOwnProperty.call(this.errorList, key)) {
          this.errorList[key] = '';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.changepassword-cont {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;

  .changepassword-tabbox {
    position: relative;
    width: 100%;
    text-align: left;
    height: 56px;

    &::before {
      content: '';
      position: absolute;
      top: 28px;
      left: 88px;
      width: 24px;
      height: 4px;
      background: $color-primary;
      transition: all 0.3s;
    }

    &.changepassword-tabbox-phone::before {
      left: 0;
    }

    &.changepassword-tabbox-email::before {
      left: 88px;
    }

    .changepassword-tab {
      display: inline-block;
      vertical-align: top;
      width: 88px;
      height: 24px;
      font-size: 16px;
      font-weight: 400;
      color: $color-text;
      line-height: 24px;
      cursor: pointer;

      &.changepassword-tab-active {
        font-size: 18px;
        color: $color-title;
        font-weight: 600;
      }
    }
  }

  .changepassword-stepbox {
    position: relative;
    width: 232px;
    flex: 0 0 auto;
    box-sizing: border-box;
    border-right: 1px solid $color-disable;
    padding-left: 40px;
    padding-bottom: 20px;
    height: 236px;
  }

  .changepassword-verify {
    position: relative;
    flex: 1;
    padding-left: 66px;

    .changepassword-errorbox {
      color: $color-error;
    }

    .changepassword-verify-item {
      width: 240px;
      margin-bottom: 24px;
      color: $color-text-secondary;

      &:last-of-type {
        margin-bottom: 0;
      }

      .verify-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        height: 16px;
        color: $color-text-secondary;
      }

      .verify-control {
        display: flex;
        align-items: center;
        color: $color-title;
        height: 32px;

        &.verify-code {
          justify-content: flex-start;

          .ux-input {
            width: 100px;
          }
        }
      }
    }

    .time-button {
      margin-left: 20px;
    }

    .min-input {
      width: 110px;
      margin-right: 20px;
    }

    .change-password-result {
      position: relative;
      display: block;
      margin: 16px auto 24px;
      width: 120px;
      height: 100px;
    }

    .result-msg {
      height: 20px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      text-align: center;
      color: $color-text;

      span {
        color: $color-primary;
      }
    }

    .change-password-noemail-img {
      width: 120px;
      height: 100px;
      margin-left: 102px;
      margin-bottom: 24px;
    }

    .change-password-noemail-txt {
      width: 306px;
      text-align: center;
      font-size: 14px;
      color: $color-text;
      line-height: 20px;
    }
  }
}

.changepassword-footer {
  text-align: right;
  padding-top: 32px;

  .ux-button {
    margin-left: 8px;
  }
}
</style>
